export const toFormData = (
  assets: AdditionalAssets
): AdditionalAssetsBannerVideoFormData => ({
  additional_assets: Object.fromEntries(
    assets.map(({ name, url, width, height }) => [
      name,
      { url, width, height, name }
    ])
  ) as Record<VideoAdditionalAssetsKeys, AdditionalAssetFormFields>
})

export const toAdditionalAssetsPayload = (
  formData: AdditionalAssetsBannerVideoFormData
): AdditionalAssets => {
  const assets = formData.additional_assets ?? {}
  const assetsValues = Object.values(assets) as AdditionalAssetFormFields[]
  const filteredAssets = assetsValues.filter(
    asset => asset?.url && asset?.width && asset?.height
  )

  const assetFormatted = (asset: AdditionalAssetFormFields) => ({
    name: asset?.name,
    url: asset?.url,
    width: Number(asset?.width),
    height: Number(asset?.height)
  })

  const formattedAssets = filteredAssets.map(assetFormatted)
  return formattedAssets
}
